module.exports = __webpack_public_path__ + "static/blended-raw-781646642d0d69bb8d631dc260f28be0.png";